import { Extension } from '@tiptap/core';
export const FontFamily = Extension.create({
    name: 'fontFamily',
    addOptions() {
        return {
            types: ['textStyle']
        };
    },
    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontFamily: {
                        default: null,
                        parseHTML: (element) => {
                            // Check if element is a font tag with face attribute
                            if (element.tagName === 'FONT' && element.getAttribute('face')) {
                                return element.getAttribute('face')?.replace(/['"]+/g, '') || null;
                            }
                            return element.style.fontFamily?.replace(/['"]+/g, '') || null;
                        },
                        renderHTML: (attributes) => {
                            if (!attributes.fontFamily) {
                                return {};
                            }
                            return {
                                style: `font-family: ${attributes.fontFamily}`
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands() {
        return {
            setFontFamily: (fontFamily) => ({ chain }) => {
                return chain().setMark('textStyle', { fontFamily }).run();
            },
            unsetFontFamily: () => ({ chain }) => {
                return chain().setMark('textStyle', { fontFamily: null }).removeEmptyTextStyle().run();
            }
        };
    }
});
